import { Component, Input } from '@angular/core';
import { getResponseIconWithColor, getResponseLabel } from 'app/events/helpers/event-response-helpers';

import { CalendarEventResponseStatusEnum, SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-rsvp-event',
  templateUrl: './rsvp-event.component.html',
})
export class RsvpEventComponent  {
  @Input() item: SearchActivityEvents.Node;

  getLabel = getResponseLabel;
  getIcon = getResponseIconWithColor;

  /**
   *
   */
  constructor() { }

  get startDate() {
    if (!this.item?.payload?.event?.startDate) { return null; }

    return new Date(this.item.payload.event.startDate
      .replace(' ', 'T')
      .replace(' UTC', 'Z')
    );
  }

  // Map status to enum, maybe this can be removed someday
  getResponseStatus(activityStatus: string): CalendarEventResponseStatusEnum {
    switch (activityStatus) {
      case 'attended':
        return CalendarEventResponseStatusEnum.Attended;
      case 'confirmed':
        return CalendarEventResponseStatusEnum.Confirmed;
      case 'declined':
        return CalendarEventResponseStatusEnum.Declined;
      case 'double_confirmed':
        return CalendarEventResponseStatusEnum.DoubleConfirmed;
      case 'no_show':
        return CalendarEventResponseStatusEnum.NoShow;
      case 'rsvp':
        return CalendarEventResponseStatusEnum.Rsvp;
      case 'tentative':
        return CalendarEventResponseStatusEnum.Tentative;
    }
    return CalendarEventResponseStatusEnum.Rsvp;
  }
}
